module.exports = __webpack_public_path__ + "img/kids-title-01.40169e5a.png";